import { Avatar } from '@lmc/ui-kit'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'

type TeamMemberAbsenceProps = {
  user?: any
}

const TeamMemberAbsence = ({ user }: TeamMemberAbsenceProps) => {
  if (!user) return null

  const handleClick = () => {
    const url = `${window.location.origin}/organisation/team/${user.id}/absences`
    window.open(url, '_blank')
  }

  return (
    <Container onClick={handleClick}>
      <Avatar size={20} url={user.picture} />
      <TextContainer>
        <Text weight="bold">{`${user.name?.first} ${user.name?.last}`}</Text>
        <Text>·</Text>
        <Text>{user.absenceType}</Text>
      </TextContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme.color.neutral.color3};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.color.status.primary};
  }
`
const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export default TeamMemberAbsence
